import createVueComponent from '../createVueComponent';

const SkipBack = createVueComponent('SkipBackIcon', [
  ['polygon', { points: '19 20 9 12 19 4 19 20', key: 'o2sva' }],
  ['line', { x1: '5', x2: '5', y1: '19', y2: '5', key: '1ocqjk' }],
]);

export default SkipBack;
